import { useState, useEffect, useCallback } from 'react';
import { Container } from '../../components/content';
import styles from '../../styles/order.module.scss';
import {Link, useLocation, useNavigate, useParams} from 'react-router-dom';
import { Button } from 'antd';
import ContentLayout from '../../layout/ContentLayout';
import GenericTable from '../../components/tables/GenericTable';
import {fetchOrder, updateOrderStatus, editOrderContents} from '../../api/webshop-products-orders-api';
import { formatPriceWithCurrency } from '../../utils/formatPrice';
import OrderDetailsTable from './orderDetailsTable';
import OrderCommissionsAndDiscounts from './orderCommissionsAndDiscounts';
import CreateOrderModal from '../../components/modals/CreateOrderModal';
import { isOrderEditable } from '../../utils/orderEditability';
import {toast} from "react-toastify";

const SingleOrder = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const { id } = params;
  const [order, setOrder] = useState(null);
  const [isEditOrderModalOpen, setIsEditOrderModalOpen] = useState(false);
  const [editOrderLoading, setEditOrderLoading] = useState(false);

  const dataBasicInfo = [
    { info: 'ID porudžbine', value: '#ASDFGH123' },
    { info: 'Korisnik', value: 'Marko Marković' },
    { info: 'Datum porudžbine', value: '15.06.2024.' },
    { info: 'Ukupna cena', value: '5.000' },
    { info: 'Status porudžbine', value: 'Obrađena' },
  ];
  const breakdown = order?.discountInfo?.breakdown ?? [];
  const enrichedProducts = (order?.products ?? []).map((p) => {
    const entry = breakdown.find((b) => b.productId === (p.productId?._id ?? p.productId)?.toString());
    return { ...p, discountAmount: entry?.discountAmount ?? 0, discountPercent: entry?.discountPercent ?? 0 };
  });
  const hasAnyDiscount = enrichedProducts.some((p) => p.discountAmount > 0);

  const columnsProducts = [
    { key: 'name', label: 'Proizvod' },
    {
      key: 'price',
      label: 'Jedinična cena',
      render: (val) => <span>{formatPriceWithCurrency(val || 0)}</span>,
    },
    {
      key: 'quantity',
      label: 'Količina',
      render: (val) => <span>x{val}</span>,
    },
    ...(hasAnyDiscount ? [{
      key: 'discountAmount',
      label: 'Kol. popust',
      render: (val, row) =>
        row.discountAmount > 0 ? (
          <span style={{ color: '#1a7f37', fontWeight: 600 }}>
            -{formatPriceWithCurrency(row.discountAmount)} ({row.discountPercent}%)
          </span>
        ) : (
          <span style={{ color: '#aaa' }}>—</span>
        ),
    }] : []),
    {
      key: 'total',
      label: 'Ukupna cena',
      render: (val, row) => (
        <span>{formatPriceWithCurrency(row?.price * row?.quantity || 0)}</span>
      ),
    },
  ];

  const columnsOrderDetails = [
    { key: 'info', label: 'Informacija' },
    { key: 'value', label: 'Vrednost' },
  ];

  const loadOrder = useCallback(async () => {
    const { data, error } = await fetchOrder({ id });

    if (!error) {
      setOrder(data);
    } else {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    loadOrder();
  }, [loadOrder]);

  const handleStatusUpdate = async (newStatus) => {
    const { data, error } = await updateOrderStatus(id, newStatus);

    if (error) {
      toast.error('Došlo je do greške pri ažuriranju statusa porudžbine');
      throw new Error(error);
    }
    setOrder(prev => ({ ...prev, status: newStatus }));
    toast.success('Status porudžbine je uspešno ažuriran');
  };

  const handleEditOrder = async (payload) => {
    setEditOrderLoading(true);
    const { data, error } = await editOrderContents(id, payload);
    setEditOrderLoading(false);
    if (error) {
      toast.error(error);
      return;
    }
    setOrder(data);
    toast.success('Porudžbina uspešno izmenjena.');
    setIsEditOrderModalOpen(false);
  };

  console.log('fetched order:', order);
  const additionalData = {
    orderNumber: order?.orderNumber,
    date: order?.createdAt,
    lastEditedAt: order?.lastEditedAt,
    status: order?.status,
    subtotal: order?.subtotal,
    user: order?.customerDetails,
    totalWithDiscount: order?.total,
    shippingAddress: order?.shippingAddress,
    deliveryFee: order?.deliveryFee,
    payment: order?.payment,
    agent: order?.agent,
    channel: order?.channel,
    referralDoctor: order?.referral?.doctor,
    isMentorPackage: order?.isMentorPackage,
    discountLabel: order?.discountLabel,
  };
  
  return (
    <>
      <Container className={styles.order}>
        <Link to={location.state?.from || '/narudzbine'} state={location.state?.backState} className="link_btn">
          <img alt="back image" src="/assets/icons/chevron.svg" />
          <span>Nazad</span>
        </Link>
        <div>
          <ContentLayout pt={true}>
            <div className={`${styles.order__inner} orderDetails_wrapper`}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <p className="title">Detalji porudžbine: {order?._id}</p>
                {isOrderEditable(order) && (
                  <Button className="btn-primary" onClick={() => setIsEditOrderModalOpen(true)}>
                    Izmeni narudžbinu
                  </Button>
                )}
              </div>
              <div>
                <GenericTable
                  data={enrichedProducts}
                  columns={columnsProducts}
                  grayTheme={true}
                  // mobNoScroll={true}
                />
              </div>
              <div>
                <OrderDetailsTable data={additionalData} onStatusUpdate={handleStatusUpdate} />
              </div>
              <div>
                <OrderCommissionsAndDiscounts order={order} />
              </div>
            </div>
          </ContentLayout>
        </div>
      </Container>
      <CreateOrderModal
        isOpen={isEditOrderModalOpen}
        onClose={() => setIsEditOrderModalOpen(false)}
        onConfirm={handleEditOrder}
        loading={editOrderLoading}
        mode="edit"
        order={order}
      />
    </>
  );
};
export default SingleOrder;
